export default "__VITE_ASSET__6LQNOw0S__"